import { Result, Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

const NoPermissionPage = () => {
    const navigate = useNavigate();

    return (
        <Result
            status="403"
            title="Access Denied"
            subTitle="Sorry, you don't have permission to access this page."
            extra={
                <Space>
                    <Button
                        type="primary"
                        onClick={() => navigate(-2)}
                        style={{ fontFamily: "SF Pro Display" }} // Optional: Ensure font consistency
                    >
                        Go Back
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => navigate('/')}
                        style={{ fontFamily: "SF Pro Display" }} // Optional: Ensure font consistency
                    >
                        Home
                    </Button>
                </Space>
            }
        />
    );
};

export default NoPermissionPage;
